import api from "API/Api"
import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"

const EditServiceItem = () => {
  const { id } = useParams()
  const [data, setData] = useState({})
  const [serviceTypes, setServiceTypes] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getInfo = async () => {
      try {
        const [itemsRes, typesRes] = await Promise.all([
          api.get("service-items"),
          api.get("service-types")
        ])
        const items = Array.isArray(itemsRes.data.data) ? itemsRes.data.data : []
        const found = items.find(i => i.id == id)
        if (found) setData(found)
        setServiceTypes(Array.isArray(typesRes.data.data) ? typesRes.data.data : [])
      } catch (e) { console.error(e) }
    }
    getInfo()
  }, [id])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const res = await api.put("service-items/" + id, values)
      if (res.data.success === true) setSubmitted(true)
    } catch (error) {
      // Handled by global interceptor
    }
    setLoading(false)
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Edit Service Item</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/service-items" className="dashBtn">
                <i className="fas fa-chevron-left"></i> <b>Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm style={{ position: "relative" }} className="form-horizontal"
            onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
            <div className="mb-3">
              <AvField name="service_type_id" label="Service Type" type="select" className="form-control" required
                value={data.service_type_id || ""}>
                <option value="">-- Select Service Type --</option>
                {serviceTypes.map(st => (
                  <option key={st.id} value={st.id}>{st.name}</option>
                ))}
              </AvField>
            </div>
            <div className="mb-3">
              <AvField name="name" label="Item Name" value={data.name || ""} className="form-control"
                placeholder="Enter item name" type="text" required />
            </div>
            <div className="mb-3">
              <AvField name="price" label="Price (₹)" value={data.price || ""} className="form-control"
                placeholder="Enter price" type="number" />
            </div>
            <div className="mb-3">
              <AvField name="unit" label="Unit" value={data.unit || ""} className="form-control"
                placeholder="e.g. per visit, per kg" type="text" />
            </div>
            <div className="mb-3">
              <AvField name="status" label="Status" type="select" className="form-control" required
                value={data.status || "active"}>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </AvField>
            </div>
            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success"><strong>Service Item Updated!</strong></UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                  {loading ? (<><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></>) : (<span>Update Service Item</span>)}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditServiceItem
